import { useQuery } from '@tanstack/react-query'
import { useRouterState } from '@tanstack/react-router'
import { heldFacetsOf } from '@volee/api-client'

import { meQueryOptions } from '../auth/me.ts'
import { navigationEntries, type NavigationEntry } from './entries.ts'

// A file of its own and not folded into `nav-sections.tsx`: `react-refresh/only-export-components`
// refuses a hook exported beside a component, and it is an error in this repo's lint.

/** The menu of whoever is signed in, here. `heldFacetsOf` and not `rolesOf`: a menu built on the
 *  bypass's widening offers a presidente «La tua famiglia» — see
 *  apps/frontend/docs/la-societa.md. */
export function useNavigationEntries(): readonly NavigationEntry[] {
  const { data: me } = useQuery(meQueryOptions)
  const currentPath = useRouterState({ select: (status) => status.location.pathname })
  return navigationEntries(heldFacetsOf(me ?? null), currentPath)
}
